(function () {
    'use strict';

    angular
        .module('app.translations')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider.state('home.adminMentionTranslations', {
                requireLogin: true,
                url: 'mention/translations',
                templateUrl: 'app/admin/mention/translations/translations.html?app_v=deployDate',
                data: {
                    authorizedRoles: ['Administrator', 'Achoo Analyst'],
                    navMarker: ['mention', 'translations']
                },
                controller: 'translationsCtrl'
            })
        }]);
})();